import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import { Document } from '@contentful/rich-text-types';

export interface JSONLDarguments {
  jobTitle?: string;
  jobDescription?: Document;
  createdAt?: Date;
  updatedAt?: Date;
  jobLocation?: {
    streetAddress: string;
    addressLocality: string;
    addressRegion: string;
    postalCode: string;
  };
}
export const buildJSONLD = ({
  jobTitle,
  jobDescription,
  createdAt,
  updatedAt,
  jobLocation,
}: JSONLDarguments) => {
  const parsedDescription =
    jobDescription && documentToHtmlString(jobDescription);

  return {
    '@context': 'http://schema.org',
    '@type': 'JobPosting',
    title: jobTitle,
    description: parsedDescription,
    datePosted: updatedAt || createdAt,
    jobLocation: {
      '@type': 'Place',
      address: {
        '@type': 'PostalAddress',
        streetAddress: jobLocation?.streetAddress ?? '',
        addressLocality: jobLocation?.addressLocality ?? '',
        addressRegion: jobLocation?.addressRegion ?? '',
        postalCode: jobLocation?.postalCode ?? '',
        addressCountry: 'DE',
      },
    },
    hiringOrganization: {
      '@type': 'Organization',
      url: 'https://www.commerzbuilding.de',
      name: 'Commerz Building and Management GmbH',
      logo: 'https://www.commerzbuilding.de/logo-cbm.png',
    },
  };
};
